import React from 'react'

const LandingFooter = () => (
  <footer className='landing-footer'>
    <div className='landing-shell landing-footer__inner'>
      <div className='footer-left'>
        <div className='footer-logo'>
          co<span>&middot;</span>bee
        </div>
        <div className='footer-tagline'>Good things must share!</div>
      </div>

      <div className='footer-right'>
        <div className='footer-copy'>© 2024 Co-bee. All rights reserved.</div>
        <a href='/policy' className='footer-privacy'>
          Our Privacy Statement
        </a>
      </div>
    </div>
  </footer>
)

export default LandingFooter
